@if (actingUser(); as actor) {
  <div
    role="status"
    class="flex items-center gap-3 rounded-full border px-4 py-1.5 text-base shadow-sm"
    [class]="
      endingSoon()
        ? 'border-red-300 bg-red-50 text-red-900 dark:border-red-700 dark:bg-red-950 dark:text-red-100'
        : 'border-amber-300 bg-amber-50 text-amber-900 dark:border-amber-700 dark:bg-amber-950 dark:text-amber-100'
    ">
    <i class="pi pi-user-edit text-base" aria-hidden="true"></i>
    <span class="flex flex-col leading-tight">
      <span class="font-semibold">Signed in as {{ userName() }}</span>
      <span class="text-sm opacity-80">Everything you do is recorded as {{ actor.fullName }} as {{ userName() }}</span>
    </span>
    <span class="whitespace-nowrap text-sm font-medium tabular-nums">
      @if (endingSoon()) {
        Ends in {{ minutesLeft() }} min. Save your work.
      } @else {
        {{ minutesLeft() }} min left
      }
    </span>
    <p-button label="End session" size="small" severity="secondary" [loading]="ending()" (onClick)="endSession()" />
  </div>
}
